import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import styles from './formdata.styl'

export default class FormData extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.any,
    nowrap: PropTypes.bool,
    intlKey: PropTypes.string
  }

  render() {
    const { label, children, intlKey, nowrap } = this.props

    return (
      <dl className={`form-group ${styles.title}`}>
        <dt
          className={cx(`control-label ${styles.title}`, {
            [styles.nowrap]: nowrap
          })}
        >
          {intlKey ? (
            <FormattedMessage id={intlKey} defaultMessage={label} />
          ) : (
            label
          )}
        </dt>
        <dd className={styles.data}>{children}</dd>
      </dl>
    )
  }
}
